<template>
  <b-container class="py-4">
    <h1>Billing</h1>
    <p class="card-text">All the plans are free for now, choose the one that suits you best.</p>
    <hr />
    <b-row class="mb-1">
      <b-col v-for="plan in plans" :key="`plan-col-${plan.uid}`">
        <plan-box :plan="plan" :active="plan.uid === userPlan" :on-set="doSetPlan" />
      </b-col>
      <b-col>
        <div class="plan-card h-100">
          <h3>Business</h3>
          <div class="details">Contact Us</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="plan in plans" :key="`plan-button-${plan.uid}`">
        <b-button block v-if="plan.uid !== userPlan" @click="doSetPlan(plan.uid)">Select</b-button>
      </b-col>
      <b-col></b-col>
    </b-row>
  </b-container>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from 'vuex'
import { PlanBox } from '@/components'

export default {
  name: 'Billing',
  components: { PlanBox },
  data: () => ({
    plans: [
      {
        uid: 'trial-plan',
        title: 'Basic',
        price: 'FREE',
        items: ['5 nodes', '1 network']
      },
      {
        uid: 'starter-plan',
        title: 'Starter',
        price: '10$ / month',
        items: ['30 nodes', '2 networks', 'API', 'Event Log']
      },
      {
        uid: 'pro-plan',
        title: 'Pro',
        price: '30$ / month',
        items: [
          '1000 nodes',
          'Unlimited networks',
          'API',
          'Event Log',
          'Alerting',
          'Mult. admin account',
          'Group policy'
        ]
      }
    ]
  }),
  computed: {
    ...mapGetters(['userPlan'])
  },
  methods: {
    ...mapActions(['fetchPlans', 'getUserPlan', 'setPlan']),
    doSetPlan(uid) {
      this.setPlan(uid)
    }
  },
  created() {
    Promise.all([this.fetchPlans(), this.getUserPlan()]).catch(() => {})
  }
}
</script>
